import React from 'react';
import { Checkbox } from '../checkbox';
import { IconArrowChevronRight } from '../icons/generated';
import { Stack } from '../stack';
import { BaseText } from '../text';
import { Category } from './types';
import { getCss, getColor } from './styles';

export interface ListItemProps {
  category: Category;
  selectedKeys: Array<string>;
  onSelect: (category: Category) => void;
  onClick: (category: Category) => void;
  isSelected: (category: Category) => boolean;
  isChecked: (category: Category) => boolean;
  isIndeterminate: (category: Category) => boolean;
  multiple?: boolean;
  disabled?: boolean;
}

export const ListItem = ({
  category,
  multiple = false,
  disabled: disabledProp = false,
  onSelect,
  onClick,
  isSelected,
  isChecked,
  isIndeterminate,
}: ListItemProps) => {
  const disabled = (disabledProp || category.disabled) ?? false;

  const handleClick = (category: Category) => {
    if (disabled) {
      return;
    }
    if (category.childrenKeys) {
      onClick(category);
    }
    if (!multiple) {
      onSelect(category);
    }
  };

  const handleSelect = (category: Category) => {
    if (disabled) {
      return;
    }
    onSelect(category);
  };

  return (
    <Stack
      direction='row'
      className='pds-category-selector-list-item'
      width='100%'
      align='stretch'
      p={multiple ? '8px 12px 8px 16px' : '8px 16px'}
      css={getCss(disabled, isSelected(category), isChecked(category))}
      onClick={() => handleClick(category)}
      justify='space-between'
    >
      <Stack direction='row' gap={8} align='center' height={24}>
        {multiple && (
          <Checkbox
            checked={isChecked(category)}
            indeterminate={isIndeterminate(category)}
            disabled={disabled}
            onChange={() => handleSelect(category)}
            onClick={(e) => e.stopPropagation()}
            unstableFocusVisible={false}
          />
        )}
        <BaseText
          kind='Body_13_Regular'
          color={getColor(disabled, isSelected(category), isChecked(category), isIndeterminate(category), multiple)}
        >
          {category.name}
        </BaseText>
      </Stack>
      {category.childrenKeys && (
        <Stack direction='row' align='center'>
          <IconArrowChevronRight
            color={getColor(disabled, isSelected(category), isChecked(category), isIndeterminate(category), multiple)}
          />
        </Stack>
      )}
    </Stack>
  );
};
